import React, { useEffect, useRef, useState } from 'react';
import './poa-form-template.scss';
import { RouteComponentProps } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity } from 'app/entities/quotation/quotation.reducer';
import { getEntityByQuotationId } from 'app/entities/quotation/iban-reducer';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { PoaFormPrint } from 'app/entities/quotation/poa-form-print';

// Function to generate and download PDF
const generatePDF = (element: HTMLElement | null, fileName: string) => {
  if (!element) {
    console.error('Element to capture is null');
    return;
  }

  html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
  })
    .then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: [794, 1123],
      });

      const width = pdf.internal.pageSize.getWidth();
      const height = pdf.internal.pageSize.getHeight();
      pdf.addImage(imgData, 'PNG', 0, 0, width, height);
      pdf.save(fileName);
    })
    .catch(error => {
      console.error('Failed to generate PDF:', error);
    });
};

export const PoaFormTemplate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const quotationEntity = useAppSelector(state => state.quotation.entity);
  const ibanEntity = useAppSelector(state => state.iban.entity);
  const quotationLoading = useAppSelector(state => state.quotation.loading);
  const ibanLoading = useAppSelector(state => state.iban.loading);
  const qId = props.match.params.id;
  const captureRef = useRef<HTMLDivElement>(null);
  const [hasGenerated, setHasGenerated] = useState(false);

  useEffect(() => {
    dispatch(getEntity(qId)).catch(error => console.error('Failed to fetch quotation:', error));
    dispatch(getEntityByQuotationId(qId)).catch(error => console.error('Failed to fetch IBAN:', error));
  }, [qId]);

  useEffect(() => {
    if (!quotationLoading && !ibanLoading && quotationEntity?.amount != null) {
      if (!hasGenerated && captureRef.current) {
        setTimeout(() => {
          generatePDF(captureRef.current, `POA_Form_${qId}.pdf`);
          setHasGenerated(true);
        }, 1000);
      }
    }
  }, [quotationEntity, quotationLoading, ibanEntity, ibanLoading, hasGenerated]);

  return <PoaFormPrint captureRef={captureRef} quotationEntity={quotationEntity} ibanEntity={ibanEntity} />;
};

export default PoaFormTemplate;
